<template>
  <div>
    <div class="row justify-content-md-center">
      <div class="col-md-6 text-center">
        <h3>Welcome to the HRTec Survey Platform (HSP)</h3>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-8">
        <card>
          <div slot="header"><h4 class="card-title">Surveys</h4></div>
          <div class="row">
            <div class="col-sm-12">
              <el-table :data="availableSurveys" @sort-change="sortChange" :default-sort="defaultSort">
                <el-table-column min-width="200" :label="surveyNameLabel" prop="surveyName" :sort-method="sortName" sortable>
                  <template scope="scope"><router-link class="active-link" :to="gotoRouteLink(scope.row)">{{ scope.row.surveyName }}</router-link></template>
                </el-table-column>
                <el-table-column min-width="150" :label="createdOnLabel" prop="createdOn" :sort-method="sortDate" sortable>
                  <template scope="scope">{{ displayDate(scope.row.createdOn) }}</template>
                </el-table-column>
                <el-table-column min-width="115" align="center" label="Customizable">
                  <template scope="scope">{{ scope.row.customizationEnabled ? trueDisplayValue : falseDisplayValue }}</template>
                </el-table-column>
                <el-table-column min-width="100" align="center" label="Requires Approval">
                  <template scope="scope">{{ scope.row.requiresApproval ? trueDisplayValue : falseDisplayValue }}</template>
                </el-table-column>
                <el-table-column min-width="100" prop="activeCount" align="center" label="Instances">
                  <template scope="scope">{{ scope.row.orgSurveys.length }}</template>
                </el-table-column>
                <el-table-column min-width="100" label="Actions" align="right" v-if="isInternalAdmin">
                  <template scope="scope">
                    <router-link class="active-link" :to="{ name: 'HspSurveyLinks', params: { surveyId: scope.row.hspSurveyId }}">
                      <el-tooltip
                        content="Manage Links"
                        effect="light"
                        :open-delay="300"
                        placement="top">
                        <base-button class="btn-link p-0" type="primary" size="sm" aria-label="Manage Links" icon>
                          <i class="tim-icons icon-link-72"></i>
                        </base-button>
                      </el-tooltip>
                    </router-link>
                    <router-link class="active-link" :to="{ name: 'HspSurveyUsers', params: { surveyId: scope.row.hspSurveyId }}">
                      <el-tooltip
                        content="Manage Users"
                        effect="light"
                        :open-delay="300"
                        placement="top">
                        <base-button class="btn-link p-0" type="primary" size="sm" aria-label="Manage Users" icon>
                          <i class="tim-icons icon-single-02"></i>
                        </base-button>
                      </el-tooltip>
                    </router-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { Table, TableColumn } from 'element-ui';
  import { formatDateDefault } from 'src/modules/utils';
  import { getUserSurveys } from 'src/modules/adminActions';
  import { isNullOrEmpty, copyObject } from 'src/modules/utils';

  export default {
    name: 'Welcome',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
    },
    data() {
      return {
        trueDisplayValue: 'Yes',
        falseDisplayValue: 'No',
        surveyNameLabel: 'Survey Name',
        createdOnLabel: 'Created On',
        storedSortByKey: 'hspAdminSurveysSortBy',
        defaultSort: { prop: 'createdOn', order: 'descending' },
        availableSurveys: [],
        userSurveys: [],
      };
    },
    computed: {
      ...mapGetters({
        surveys: 'surveys',
        getSurveyById: 'getSurveyById',
        isUser: 'adminUserIsUser',
        isInternalAdmin: 'adminUserIsInternalAdmin',
        userAssignments: 'userAssignments',
      }),
    },
    methods: {
      displayDate: formatDateDefault('None'),
      sortName(a, b) {
        if (a.surveyName.toLowerCase() < b.surveyName.toLowerCase()) return -1;
        if (a.surveyName.toLowerCase() > b.surveyName.toLowerCase()) return 1;
        return 0;
      },
      sortDate(a, b) {
        let dateA = new Date(a.createdOn);
        let dateB = new Date(b.createdOn);

        return dateA - dateB;
      },
      sortChange(sortProps){
        this.defaultSort = { prop: sortProps.prop, order: sortProps.order };
        let sortByStringify = JSON.stringify(this.defaultSort);
        localStorage.setItem(this.storedSortByKey, sortByStringify);
      },
      initialize() {
        this.getAssignedSurveys();
        let storedSortBy = JSON.parse(localStorage.getItem(this.storedSortByKey));
        if (!storedSortBy) {
          return;
        }

        this.defaultSort = storedSortBy;
      },
      resolveAvailableSurveys(msg) {
        if (isNullOrEmpty(this.userSurveys)) {
          return;
        }

        this.availableSurveys = this.surveys.filter(surv =>
            this.userSurveys.findIndex(usr => 
              usr.hspSurveyId === surv.hspSurveyId ||
              surv.orgSurveys.findIndex(org => org.orgSurveyId === usr.orgSurveyId) > -1
            ) > -1
        );
      },
      getAssignedSurveys() {
        if (!this.isInternalAdmin) {
          if (!isNullOrEmpty(this.$route.params.res)) {
            this.userSurveys = JSON.parse(this.$route.params.res.userSurveys);
            this.availableSurveys = JSON.parse(this.$route.params.res.availableSurveys);
          }

          if (isNullOrEmpty(this.userSurveys)) {
            if (this.userAssignments) {
              this.userSurveys = this.userAssignments.userSurveys;
              this.resolveAvailableSurveys("From this.userAssignments available");
            }
            else {
              getUserSurveys()
                .then(response => {
                  this.userSurveys = response.data;
                  this.resolveAvailableSurveys("From getUserSurveys() promise completed");
                });
            }
          }
        }
        else {
          this.availableSurveys = this.surveys;
        }
      },
      gotoRouteLink(data) {
        const hspSurvey = this.filterSurvey(data.hspSurveyId);
        let surveyInfo = JSON.stringify(hspSurvey);
        let routeTo = { name: 'Instances', params: { surveyId: data.hspSurveyId, surveyInfo: surveyInfo }};
        if (this.isUser && hspSurvey.orgSurveys.length === 1) {
          routeTo = { 
            name: 'InstanceDashboard', 
            params: { 
              surveyId: data.hspSurveyId, 
              urlId: data.orgSurveys[0].surveyUrlId,
              routeFrom: "surveys",
              surveyInfo: surveyInfo,
            }
          };
        }

        return routeTo;
      },
      filterSurvey(surveyId) {
        let survey = {
          orgSurveys: []
        };

        let stateSurvey = this.getSurveyById(surveyId);
        if (stateSurvey) {
          survey = copyObject(stateSurvey);
          if (!isNullOrEmpty(this.userSurveys)) {
            survey.orgSurveys = survey.orgSurveys.filter(x => 
              this.userSurveys.findIndex(y => y.hspSurveyId === x.hspSurveyId || y.orgSurveyId === x.orgSurveyId) > -1
            );
          }

          if (!this.isUser) {
            survey.orgSurveys.forEach(orgSurvey => {
              orgSurvey.reviewUrl = `${process.env.VUE_APP_URL}/surveys/access/${orgSurvey.hspSurveyId}/${orgSurvey.surveyUrlId}/review`;
              orgSurvey.surveyUrl = `${process.env.VUE_APP_URL}/surveys/${orgSurvey.surveyUrlId}`;
            });
          }
        }

        return survey;
      },
    },
    created() {
      this.initialize();
    }
  };
</script>
<style>
  .cell {
    word-break: normal !important;
  }
</style>
